var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Immuable from 'immutable';

import SidePanel from "../../Layout/SidePanel";
import SearchResults from "../../Connections/components/SearchResults";
import { loadInReduxForm } from "../../Metadata/actions/actions";
import { Icon } from "../../UI";
import { Translate } from "../../I18N";
import { closePanel } from "../actions/uiActions";
import SearchForm from "./SearchEntitiesForm";
import * as actions from "../actions/actions";

class AddEntities extends Component {
  constructor(props) {
    super(props);
    this.addEntity = this.addEntity.bind(this);
    this.newEntity = this.newEntity.bind(this);
  }

  addEntity(_sharedId, entity) {
    this.props.addEntity(this.props.hubIndex, this.props.rightRelationshipIndex, entity);
  }

  newEntity() {
    this.props.selectConnection({ metadata: {} });
    this.props.loadInReduxForm(
      'relationships.metadata',
      { metadata: {} },
      this.props.templates.toJS()
    );
    this.props.closePanel();
  }

  render() {
    const { uiState, searchResults } = this.props;
    const open = Boolean(this.props.uiState.get('open'));

    return /*#__PURE__*/(
      _jsx(SidePanel, { open: open, className: "create-reference" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "sidepanel-header" }, void 0, /*#__PURE__*/
      _jsx("h1", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Add entities / documents")
      ), /*#__PURE__*/
      _jsx("button", {
        type: "button",
        className: "closeSidepanel close-modal",
        onClick: this.props.closePanel }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "times" })
      )
      ), /*#__PURE__*/

      _jsx("div", { className: "sidepanel-body" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "search-box" }, void 0, /*#__PURE__*/
      _jsx(SearchForm, {})
      ), /*#__PURE__*/
      _jsx(SearchResults, {
        results: searchResults,
        searching: uiState.get('searching'),
        onClick: this.addEntity }
      )
      ), /*#__PURE__*/
      _jsx("div", { className: "sidepanel-footer" }, void 0, /*#__PURE__*/
      _jsx("button", { type: "button", className: "btn btn-success", onClick: this.newEntity }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "plus" }), /*#__PURE__*/
      _jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Create Entity")
      )
      )
      )
      ));

  }
}













const mapStateToProps = ({ relationships, templates }) => ({
  uiState: relationships.uiState,
  searchResults: relationships.searchResults,
  hubIndex: relationships.hubActions.getIn(['addTo', 'hubIndex']),
  rightRelationshipIndex: relationships.hubActions.getIn(['addTo', 'rightRelationshipIndex']),
  templates
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      addEntity: actions.addEntity,
      closePanel,
      loadInReduxForm,
      selectConnection: actions.selectConnection
    },
    dispatch
  );
}

export { AddEntities, mapStateToProps };

export default connect(mapStateToProps, mapDispatchToProps)(AddEntities);